import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useCallback, useMemo } from "react";

import { createStorageKey } from "@/utils/storage";

export type DismissedBanner = { id: string; dismissedAt: number };

// Stored value may contain legacy string entries (from MarUsageThresholdAlert dismissals)
const dismissedBannersStateAtom = atomWithStorage<(string | DismissedBanner)[]>(
  createStorageKey("dismissed-workspace-banners"),
  [],
);

export function useDismissedBannersState() {
  const [raw, setRaw] = useAtom(dismissedBannersStateAtom);

  const entries = useMemo(
    (): DismissedBanner[] =>
      raw.map((item) =>
        typeof item === "string" ? { id: item, dismissedAt: 0 } : item,
      ),
    [raw],
  );

  const dismissBanner = useCallback(
    (id: string) => {
      setRaw((prev) => [...prev, { id, dismissedAt: Date.now() }]);
    },
    [setRaw],
  );

  return [entries, dismissBanner] as const;
}
